/**
 * @file 我的账户相关hook
 */
import { useState } from 'react';
import { ClaimType } from '@/types/claim';

/**
 * 主要控制领取收益的弹出和类型
 */
export const useShowClaimModal = () => {
  const [showClaimModal, setShowClaimModal] = useState(false);
  // 领取收益有两种类型，领取收益和领取本金
  const [claimType, setClaimType] = useState(ClaimType.Claim);

  const onOpenClaimModal = (type: ClaimType) => {
    setShowClaimModal(true);
    setClaimType(type);
  };

  const onCloseClaimModal = () => {
    setShowClaimModal(false);
  };

  return {
    claimType,
    showClaimModal,
    onOpenClaimModal,
    onCloseClaimModal,
  };
};
